import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { VisaDocumentUploadDto } from '../dtos/visa-application/visaDocumentUploadDto';
import { VisaApplicationStatusDto } from '../dtos/visa-application/visa-application.dto';
import { DataSourceService } from './data-source-service.ts';
import { VisaNoteUpdateDto } from '../dtos/visa-application/visaNoteUpdateDto';
@Injectable({
  providedIn: 'root'
})
export class VisaApplicationService {

  private apiUrl = `${environment.apiUrl}/visaapplication`;

  constructor(
    private http: HttpClient,
    private dataSourceService: DataSourceService
  ) {}
  
  // Genişletilmiş başvuru listesi (pagination)
  getVisaApplicationDataSource(): any {
    return this.dataSourceService.getDataSource(`${this.apiUrl}/VisaApplicationList`);
  }

  // // Genişletilmiş başvuru listesi (tüm veriler - eski metod burada bütün veriler çekiiliyor)
  // getVisaApplicationList(): Observable<any> {
  //   return this.http.get<any>(`${this.apiUrl}/VisaApplicationList`);
  // }

  // Ödeme sayıları için 
  getPaymentCounts(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/PaymentCounts`);
  }

  // Vize durumu / ödeme durumu güncelle
  updateStatus(entity: VisaApplicationStatusDto): Observable<any> {
    return this.http.post(`${this.apiUrl}/UpdateStatus`, entity);
  }

  updateStatusCustomer(entity: VisaNoteUpdateDto): Observable<any> {
    return this.http.post(`${this.apiUrl}/UpdateStatusCustomer`, entity);
  }

  uploadVisaDocument(dto: VisaDocumentUploadDto): Observable<any> {
    return this.http.post(`${this.apiUrl}/UploadVisaDocument`, dto);
  }
  
  deleteVisaDocument(customerId: number): Observable<any> {
    const dto: VisaDocumentUploadDto = { customerId };
    return this.http.post(`${this.apiUrl}/DeleteVisaDocument`, dto);
  }

  sendVisaNotificationEmail(dto: { customerId: number; visaApplicationId: number }): Observable<any> {
    return this.http.post(`${this.apiUrl}/SendVisaNotificationEmail`, dto);
  }

  // Dosya indirme endpoint
  downloadFile(filePath: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/DownloadFile?filePath=${encodeURIComponent(filePath)}`, {
      responseType: 'blob'
    });
  }
  
}
